import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import classes from '@nerdwallet/base-styles/classes';
import { colors, spacing } from '@nerdwallet/base-styles/variables';
import { getMaxLtvText, getMinCreditScore, getMinCreditScoreDictionary, getMinCreditScoreTypesForTooltip, getMinDownPayment, getMinDownPaymentTooltip, getMaxLoanAmount, getMaxLoanAmountTooltip, getMinLoanAmount, getMinLoanAmountTooltip } from '../selectors/mortgages';
import { getLoanTypeAndProductLabels, getCoverageAreaLabel } from '../utils/mortgages';
import { MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS } from '../constants';
import { VALUE_SIZES, FORMATS } from '../constants/drivers';
/**
 * Get the loan types & products driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverLoanTypesAndProducts = function getDriverLoanTypesAndProducts(offer) {
  return {
    id: 'loanTypesProducts',
    label: 'Loan types and products',
    value: getLoanTypeAndProductLabels(offer).join(', '),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the max LTV driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMaxLtv = function getDriverMaxLtv(offer) {
  return {
    id: 'maxLtv',
    label: 'Max LTV',
    value: getMaxLtvText(offer)
  };
};
/**
 * Get the min down payment driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMinDownPayment = function getDriverMinDownPayment(offer) {
  return {
    id: 'minDownPayment',
    label: 'Min. down payment',
    value: getMinDownPayment(offer),
    valueTooltip: getMinDownPaymentTooltip(offer)
  };
};
/**
 * Get the min down payment driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverNationalRegional = function getDriverNationalRegional(offer) {
  return {
    id: 'nationalRegional',
    label: 'National / regional',
    value: getCoverageAreaLabel(offer)
  };
};
/**
 * Get the min credit score driver
 * @param {Object} offer - The marketplace offer
 * @param {String} forcedType - The type override
 */

export var getDriverMinCreditScore = function getDriverMinCreditScore(offer) {
  var forcedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var minCreditScoreObject = getMinCreditScoreDictionary(offer);
  var minCreditScore = _get(minCreditScoreObject, forcedType) ||
  /**
   * Hack to coerce forced type to accomodate canonical enums
   */
  _get(minCreditScoreObject, forcedType === null || forcedType === void 0 ? void 0 : forcedType.toUpperCase()) || getMinCreditScore(offer);
  var creditScoreTypes = getMinCreditScoreTypesForTooltip(offer);
  var UNSAFE_valueTooltip = null; // eslint-disable-line camelcase

  var valueTooltip = null;

  if (creditScoreTypes && !_isEmpty(creditScoreTypes)) {
    var tooltipRowsSC = [];
    var tooltipRows = ''; // eslint-disable-next-line consistent-return

    creditScoreTypes.forEach(function (creditScoreType) {
      var label = MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS[creditScoreType];

      if (!label) {
        return null;
      }

      var value = _get(minCreditScoreObject, creditScoreType);

      tooltipRows += "<tr><td style=\"color:".concat(colors['neutral-darker'], ";padding-right:").concat(spacing['1'], ";\">").concat(label, ":</td><td>").concat(value, "</td><tr>");
      tooltipRowsSC.push({
        type: 'Container',
        version: '1.0.0',
        props: {
          className: classes(['display-flex', 'justify-content-space-between']),
          children: [{
            type: 'Type',
            version: '1.0.0',
            props: {
              className: classes(['margin-right-1', 'nowrap']),
              light: true,
              children: "".concat(label, ":")
            }
          }, {
            type: 'Type',
            version: '1.0.0',
            props: {
              className: classes('nowrap'),
              color: 'neutral-darkest',
              children: value
            }
          }]
        }
      });
    });
    UNSAFE_valueTooltip = "<table style=\"text-align:left;\">".concat(tooltipRows, "</table>"); // eslint-disable-line camelcase

    valueTooltip = {
      type: 'Container',
      version: '1.0.0',
      props: {
        children: tooltipRowsSC
      }
    };
  }

  return {
    id: 'minCreditScore',
    label: 'Min. credit score',
    labelTooltip: 'Minimum credit score on top loans; other loan types or factors may selectively influence minimum credit score standards',
    value: minCreditScore,
    UNSAFE_valueTooltip: UNSAFE_valueTooltip,
    valueTooltip: valueTooltip
  };
};
/**
 * Get the max loan amount driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "max loan amount" driver.
 */

export var getDriverMaxLoanAmount = function getDriverMaxLoanAmount(offer) {
  return {
    id: 'maxLoanAmount',
    label: 'Max. loan amount',
    value: getMaxLoanAmount(offer),
    valueTooltip: getMaxLoanAmountTooltip(offer),
    valueFormat: FORMATS.CURRENCY
  };
};
/**
 * Get the min loan amount driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "min loan amount" driver.
 */

export var getDriverMinLoanAmount = function getDriverMinLoanAmount(offer) {
  return {
    id: 'minLoanAmount',
    label: 'Min. loan amount',
    value: getMinLoanAmount(offer),
    valueTooltip: getMinLoanAmountTooltip(offer),
    valueFormat: FORMATS.CURRENCY
  };
};